var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1977 35.2634V39.4974C10.1977 39.6146 9.88999 40.1567 9.77279 40.2739C9.01096 41.0357 7.79497 40.6255 7.47266 39.6586V31.7912C7.60451 31.044 8.13193 30.6924 8.86446 30.6338C11.2525 30.4287 13.9482 30.7657 16.3655 30.6778C17.3618 30.9415 17.8159 32.0842 17.1274 32.9047C17.0248 33.0365 16.5267 33.3735 16.3948 33.3735H12.322C12.3952 33.6079 12.6296 33.8716 12.7908 34.0621C19.9403 42.2957 33.4334 40.3325 37.9165 30.4141C38.9274 28.1725 39.0006 26.7221 39.2204 24.3487C39.3962 22.327 41.7842 22.5174 41.96 23.9971C42.1358 25.4768 41.6963 27.7623 41.2714 29.2274C38.7223 38.003 29.7854 43.3358 20.79 41.651C16.5853 40.8599 12.8934 38.5305 10.1684 35.2634H10.1977Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2098 13.0825V9.00964C38.2098 9.00964 38.3417 8.54082 38.3563 8.48222C38.8251 7.32483 40.5539 7.41273 40.9202 8.59942V16.5547C40.9055 16.9942 40.4513 17.5216 40.0265 17.6095C39.3965 17.7414 38.7079 17.6095 38.078 17.6242C36.0269 17.6242 33.9758 17.6388 31.9247 17.6095C30.738 17.2432 30.6501 15.5145 31.8075 15.0457C31.8808 15.0164 32.3056 14.8992 32.3349 14.8992H36.0562C34.137 12.3646 31.2362 10.46 28.1742 9.62496C19.5597 7.26622 10.5056 12.9946 9.275 21.8875C9.15779 22.7079 9.275 24.3048 8.73293 24.8615C7.8832 25.7259 6.37419 25.1106 6.34489 23.9092C6.18373 17.7121 10.3152 11.427 15.6187 8.52617C23.2516 4.35077 32.8184 6.34324 38.2098 13.0825Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.9aed1a1de2fa9d3d7dcebc2e43df25f1.svg";
export { ForwardRef as ReactComponent };